import { useState, useEffect } from 'react';

export default function OfferEditor() {
  const [offers, setOffers] = useState(null);

  // Pobranie danych
  useEffect(() => {
    fetch('/data/offer.json')
      .then((res) => res.json())
      .then(setOffers)
      .catch(console.error);
  }, []);

  if (!offers) return <p>Ładowanie danych…</p>;

  const updateOffer = (groupIndex, offerIndex, field, value) => {
    setOffers((prev) => {
      const newData = { ...prev };
      newData.data[groupIndex].offers[offerIndex][field] =
        field === 'price' || field === 'period' ? Number(value) : value;
      return newData;
    });
  };

  const saveOffers = async () => {
    try {
      const res = await fetch('/data/updateOffer.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(offers),
      });
      const result = await res.json();
      if (result.success) alert('Zapisano dane na serwerze!');
      else alert('Błąd: ' + result.error);
    } catch (err) {
      console.error(err);
      alert('Błąd połączenia z serwerem');
    }
  };
  console.log(offers);
  return (
    <div
      style={{ maxWidth: 800, margin: '40px auto', fontFamily: 'sans-serif' }}
    >
      <h1>Edytor ofert</h1>

      {offers.data.map((group, gIdx) => (
        <div
          key={gIdx}
          style={{
            marginBottom: 32,
            padding: 16,
            border: '1px solid #ccc',
            borderRadius: 8,
          }}
        >
          <h2>{group.name}</h2>
          {group.offers.map((offer, oIdx) => (
            <div
              key={oIdx}
              style={{
                display: 'grid',
                gridTemplateColumns: '2fr 1fr 1fr',
                gap: 12,
                marginBottom: 8,
                color: 'black',
              }}
            >
              <input
                type="text"
                value={offer.name}
                onChange={(e) =>
                  updateOffer(gIdx, oIdx, 'name', e.target.value)
                }
              />
              <input
                type="number"
                value={offer.period}
                onChange={(e) =>
                  updateOffer(gIdx, oIdx, 'period', e.target.value)
                }
              />
              <input
                type="number"
                value={offer.price}
                onChange={(e) =>
                  updateOffer(gIdx, oIdx, 'price', e.target.value)
                }
              />
            </div>
          ))}
        </div>
      ))}

      <button
        onClick={saveOffers}
        style={{ padding: '10px 20px', fontSize: 16 }}
      >
        Zapisz zmiany
      </button>
    </div>
  );
}
